import type {PermissionsRecordType} from '../permissions';

export const rentalOrderPermissions = {
  createRentalOrder: {
    resourceId: 'RENTAL_ORDER',
    actionId: 'CREATE',
    scopes: [],
  },
  readRentalOrder: {
    resourceId: 'RENTAL_ORDER',
    actionId: 'READ',
    scopes: ['PARTICIPATION', 'BRANCH'],
  },
  rentalOrderCustomFields: {
    resourceId: 'RENTAL_ORDER',
    actionId: 'CUSTOM_FIELDS_PAYLOAD_UPDATE',
    scopes: [],
  },
  updateRentalOrder: {
    resourceId: 'RENTAL_ORDER',
    actionId: 'UPDATE',
    scopes: [],
  },
  cancelRentalOrder: {
    resourceId: 'RENTAL_ORDER',
    actionId: 'CANCEL',
    scopes: [],
  },
  rentalOrderInvoice: {
    resourceId: 'RENTAL_ORDER',
    actionId: 'INVOICE',
    scopes: [],
  },
  rentalOrderReserveVehicle: {
    resourceId: 'RENTAL_ORDER',
    actionId: 'RESERVE_VEHICLE',
    scopes: [],
  },
  rentalOrderRentVehicle: {
    resourceId: 'RENTAL_ORDER',
    actionId: 'RENT_VEHICLE',
    scopes: [],
  },
  rentalOrderReturnVehicle: {
    resourceId: 'RENTAL_ORDER',
    actionId: 'RETURN_VEHICLE',
    scopes: [],
  },
  rentalOrderAssignServiceOrder: {
    resourceId: 'RENTAL_ORDER',
    actionId: 'ASSIGN_SERVICE_ORDER',
    scopes: [],
  },
  createRentalOrderContractDocument: {
    resourceId: 'RENTAL_ORDER',
    actionId: 'CREATE_ORDER_CONTRACT_DOCUMENT',
    scopes: [],
  },
  createRentalOrderReturnDocument: {
    resourceId: 'RENTAL_ORDER',
    actionId: 'CREATE_ORDER_RETURN_DOCUMENT',
    scopes: [],
  },
  deleteRentalOrder: {
    resourceId: 'RENTAL_ORDER',
    actionId: 'DELETE',
    scopes: [],
  },
  rentalOrderParticipationAssignOrganizationalUnit: {
    resourceId: 'RENTAL_ORDER',
    actionId: 'PARTICIPATION_ASSIGN_ORGANIZATIONAL_UNIT_COMMAND',
    scopes: [],
  },
  rentalOrderParticipationAssignUser: {
    resourceId: 'RENTAL_ORDER',
    actionId: 'PARTICIPATION_ASSIGN_USER_COMMAND',
    scopes: [],
  },
  rentalOrderParticipationTransferOwnershipToOrganizationalUnit: {
    resourceId: 'RENTAL_ORDER',
    actionId: 'PARTICIPATION_TRANSFER_OWNERSHIP_TO_ORGANIZATIONAL_UNIT_COMMAND',
    scopes: [],
  },
  rentalOrderParticipationTransferOwnershipToUser: {
    resourceId: 'RENTAL_ORDER',
    actionId: 'PARTICIPATION_TRANSFER_OWNERSHIP_TO_USER_COMMAND',
    scopes: [],
  },
  rentalOrderParticipationUnassignOrganizationalUnit: {
    resourceId: 'RENTAL_ORDER',
    actionId: 'PARTICIPATION_UNASSIGN_ORGANIZATIONAL_UNIT_COMMAND',
    scopes: [],
  },
  rentalOrderParticipationUnassignUser: {
    resourceId: 'RENTAL_ORDER',
    actionId: 'PARTICIPATION_UNASSIGN_USER_COMMAND',
    scopes: [],
  },
  rentalOrderParticipationCreateParticipationBySystem: {
    resourceId: 'RENTAL_ORDER',
    actionId: 'PARTICIPATION_CREATE_PARTICIPATION_BY_SYSTEM_COMMAND',
    scopes: [],
  },
  rentalOrderParticipationCreateParticipationByUser: {
    resourceId: 'RENTAL_ORDER',
    actionId: 'PARTICIPATION_CREATE_PARTICIPATION_BY_USER_COMMAND',
    scopes: [],
  },
} satisfies PermissionsRecordType;
